import Text from '../Base/Text/Text';
import styles from './QuestionnaireItem.module.scss';

export default function QuestionnaireItem(props) {
	const { user, onClick } = props;

	const handleClick = () => {
		onClick?.({
			id: user.id,
			label: user.label,
		});
	};

	return (
		<div
			className='autocomplete-custom-patient-search no-border'
			onClick={handleClick}>
			<div className='autocomplete-custom-patient-search__content'>
				<div className='autocomplete-custom-patient-search__content__title'>
					<Text tx={user.label} />
				</div>
			</div>
		</div>
	);
}

QuestionnaireItem.propTypes = {};
